import styled from "styled-components";

export const StyleUnorderedList = styled.ul`
  list-style: ${(props) => props.listStyle || "none"};
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  margin: ${(props) => props.margin || "0px"};
  padding: ${(props) => props.padding || "0px"};
  z-index: ${(props) => props.zIndex};
`;

export const StyleListItem = styled.li`
  display: ${(props) => props.display || "flex"};
  justify-content: ${(props) => props.justifyContent || "left"};
  align-items: ${(props) => props.alignItems || "center"};
  padding: ${(props) => props.padding};
  border-top: ${(props) => props.borderTop || "1px solid var(--line)"};
  width: ${(props) => props.width};
  z-index: ${(props) => props.zIndex};
`;

export const StyleListItemNoBorderTop = styled.li`
  display: ${(props) => props.display || "flex"};
  justify-content: ${(props) => props.justifyContent || "left"};
  align-items: ${(props) => props.alignItems || "center"};
  padding: ${(props) => props.padding};
  border-top: ${(props) => props.borderTop || "0px solid rgba(0,0,0,0)"};
  width: ${(props) => props.width};
  z-index: ${(props) => props.zIndex};
`;
